import { o as t, c, a as o } from "./core.0767a1be.js";
const e = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1024 1024"
}, r = /* @__PURE__ */ o("path", {
  fill: "currentColor",
  d: "M637 443H325c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h312c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z"
}, null, -1), l = /* @__PURE__ */ o("path", {
  fill: "currentColor",
  d: "M921 867 775 721c122.1-148.9 113.6-369.5-26-509-148-148.1-388.4-148.1-537 0-148.1 148.6-148.1 389 0 537 139.5 139.6 360.1 148.1 509 26l146 146c3.2 2.8 8.3 2.8 11 0l43-43c2.8-2.7 2.8-7.8 0-11zM696 696c-118.8 118.7-311.2 118.7-430 0-118.7-118.8-118.7-311.2 0-430 118.8-118.7 311.2-118.7 430 0 118.7 118.8 118.7 311.2 0 430z"
}, null, -1), n = [
  r,
  l
];
function s(a, d) {
  return t(), c("svg", e, n);
}
const h = { render: s };
export {
  h as default,
  s as render
};
//# sourceMappingURL=zoom-out.b73582c2.js.map
